// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__31M1c","errors":"Errors_errors__2lcZT"};